import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import toolsIcon from 'images/icons/tools.svg';

import Button from 'components/Button';
import InlinePage from 'components/Page/Inline';
import Link from 'components/links/Link';
import Svg from 'components/shared/Svg';
import ReadableWidthTemplate from 'components/templates/ReadableWidth';
import Types from 'conf/types';

import './index.scss';

export default function CpicPage({}) {
  return (
    <ReadableWidthTemplate>
      <h1>CPIC</h1>

      <div className="glass-blur section-links">
        <div className="row">
          <div className="col-lg">
            <Link href="/cpic/guidelines"><h3><Svg src={Types.guidelineAnnotation.icon} inline={true} />Guidelines</h3></Link>
          </div>
          <div className="col-lg">
            <Link href="/cpic/pairs">
              <h3>
                <Svg src={Types.connection.icon} inline={true} />
                Genes-Drugs
              </h3>
            </Link>
          </div>
          <div className="col-lg">
            <Link href="/publications?cat=CPIC&cat=guideline"><h3><Svg src={Types.literature.icon} inline={true} />Publications</h3></Link>
          </div>
          <div className="col-lg">
            <Link href="/page/cpicResources"><h3><Svg src={toolsIcon} ariaHidden={true} inline={true} />Resources</h3></Link>
          </div>
        </div>
      </div>

      <InlinePage id="cpicHomepage" showTitle={false} />

      <div className="mt-5">
        <h3 id="contact">Contact</h3>
        <div className="row">
          <div className="col-lg">
            <p>Contact us with any questions or comments.</p>
            <Button href="mailto:contact@cpicpgx.org">Contact CPIC</Button>

            <div className="alert alert-info mt-3">
              <FontAwesomeIcon icon={['fas', 'circle-info']} /> Have a question or comment about allele function or diplotype-phenotype tables?
              <Button className="btn-sm btn-outline-info ml-2" href="https://www.surveymonkey.com/r/9Q95LGX">Submit a request</Button>
            </div>
          </div>
          <div className="col-lg">
            <p>Get announcements including guideline updates, news, and solicitation of feedback.</p>
            <Button href="https://blog.clinpgx.org/tag/cpic">Subscribe</Button>
          </div>
        </div>
      </div>
    </ReadableWidthTemplate>
  );
}
